import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { useI18n } from "@/i18n";

/**
 * Gate a route behind authentication. Sends users to /login?next=<original-path>
 * so they return to where they were after sign-in.
 */
export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const { isRTL } = useI18n();
  const location = useLocation();

  if (loading) {
    return (
      <div className="max-w-2xl mx-auto p-12 text-center text-[#5C544F]" data-testid="auth-gate-loading">
        {isRTL ? "جارٍ التحقق..." : "Checking..."}
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
